import { render, staticRenderFns } from "./activitiesSignupView.vue?vue&type=template&id=2d586563&scoped=true"
import script from "./activitiesSignupView.vue?vue&type=script&lang=js"
export * from "./activitiesSignupView.vue?vue&type=script&lang=js"
import style0 from "./activitiesSignupView.vue?vue&type=style&index=0&id=2d586563&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d586563",
  null
  
)

export default component.exports